import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn } from '@angular/router';
import { PageSeoData, SeoService } from '@shared/helpers/seo.service';

export const SeoCanActivateGuard: CanActivateFn = (route) => {
  applySeoData(route);
  return true;
};

export const SeoCanActivateChildGuard: CanActivateChildFn = (route) => {
  applySeoData(route);
  return true;
};

function applySeoData(route: ActivatedRouteSnapshot): void {
  const seoService = inject(SeoService);

  const seo = route.data.seo as PageSeoData;

  if (!seo) {
    return;
  }

  seoService.setPageSeoData(seo);
}
